import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRestaurant } from '../../context/RestaurantContext';

const useCreateConversation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // Get the navigate function
  const { restaurantId } = useRestaurant();

  const createConversation = async (employeeId, contextId, type) => {
    setIsLoading(true);
    setError(null);
    
    let bodyData = { employeeId, type };
    
    // Add restaurantId for empresas
    if (restaurantId) {
      bodyData.restaurantId = restaurantId;
    }
    
    if (type === 'applicant') {
      bodyData.jobPostId = contextId;
    }

    if (type === 'talent') {
      bodyData.talentPoolId = contextId;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/create-conversation`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (response.ok) {
        const data = await response.json();
        setIsLoading(false);
        return data.data; 
      }

      if (response.status === 401) {
        navigate('/empresas/entrar'); 
        return null;
      } else {
        const errorData = await response.json().catch(() => ({ message: 'Failed to create conversation.' }));
        setError(errorData.message || 'Failed to create conversation.');
        return null;
      }
    } catch (err) {
      setError(err.message || 'Failed to create conversation.');
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { createConversation, isLoading, error };
};

export default useCreateConversation;
